/**
 * The conversation a piece of chat content was rendered in: its session id.
 * Each pane that renders a conversation's messages provides it, so a link an
 * agent wrote can carry the conversation it was offered in as navigation
 * state, which the platform sets and the model cannot write. A run started
 * from such a link hangs under that conversation; content rendered outside a
 * conversation has none (null).
 */
import { createContext, useContext } from 'react'

export const ConversationContext = createContext<string | null>(null)

/** The session id of the conversation rendering this content, or null. */
export function useConversationId(): string | null {
  return useContext(ConversationContext)
}

/** The navigation state an in-app link from a conversation carries. */
export interface ConversationLinkState {
  parent: string
}
